export const RouteNames = {
    // Auth routes
    LOGIN: '/login',
    AUTH_CALLBACK: '/auth/callback',
    // Personal dashboard for a quick navigation and overview
    PERSONAL_DASHBOARD: '/',
    /** Organization level */ // Dashboard/onboarding for an organization
    ORGANIZATION: '/org/$organization',
    ORGANIZATION_PROJECTS: '/org/$organization/projects',
    ORGANIZATION_MANAGED_APPLICATIONS: '/org/$organization/managed-applications',
    ORGANIZATION_TEAM_LIST: '/org/$organization/settings/teams',
    ORGANIZATION_TEAM: '/org/$organization/settings/teams/$team',
    ORGANIZATION_PEOPLE: '/org/$organization/settings/people',
    /** Organization settings */ ORGANIZATION_SETTINGS: '/org/$organization/settings',
    ORGANIZATION_MEMBERSHIP: '/org/$organization/settings/membership',
    ORGANIZATION_AUDIT_LOG: '/org/$organization/settings/audit-log',
    ORGANIZATION_SUBSCRIPTION: '/org/$organization/settings/subscription',
    ORGANIZATION_SUBSCRIPTION_MANAGE: '/org/$organization/settings/subscription/manage',
    ORGANIZATION_PAYMENT_METHODS: '/org/$organization/settings/payment-methods',
    ORGANIZATION_BILLING_HISTORY: '/org/$organization/settings/billing-history',
    ORGANIZATION_DEPLOYMENT_INTEGRATION_LIST: '/org/$organization/settings/deployment-integrations',
    ORGANIZATION_DEPLOYMENT_INTEGRATION_OVERVIEW: '/org/$organization/settings/deployment-integrations/$integrationType',
    ORGANIZATION_DEPLOYMENT_INTEGRATION: '/org/$organization/settings/deployment-integrations/$integrationType/$integrationName',
    ORGANIZATION_DEPLOYMENT_INTEGRATION_ADD: '/org/$organization/settings/deployment-integrations/$integrationType/add',
    ORGANIZATION_DEPLOYMENT_INTEGRATION_EDIT: '/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/edit',
    ORGANIZATION_SERVER_TOKENS: 'server-tokens',
    ORGANIZATION_SERVER_TOKEN_NEW: 'server-tokens/generate',
    ORGANIZATION_SERVER_TOKEN_EDIT: 'server-tokens/$token',
    /** Project level */ PROJECT_OVERVIEW: '/org/$organization/$project',
    PROJECT_APPLICATION_LIST: '/org/$organization/$project/applications',
    // todo: change this when we have a project level
    PROJECT_SETTINGS_GENERAL: '/org/$organization/$project/settings/general',
    PROJECT_SETTINGS_DEPLOYMENT_INTEGRATION_LIST: '/org/$organization/$project/devops/deployment-integrations',
    PROJECT_SETTINGS_COLLABORATORS_AND_TEAM: '/org/$organization/$project/settings/collaborations-teams',
    PROJECT_SETTINGS_AUDIT_LOG: '/org/$organization/$project/settings/audit-log',
    /** Application level */ APPLICATION_OVERVIEW: '/org/$organization/$project/app/$application',
    APPLICATION_ENVIRONMENTS: '/org/$organization/$project/app/$application/environments/',
    APPLICATION_VERSIONS: '/org/$organization/$project/app/$application/versions',
    APPLICATION_VERSION_DETAIL: '/org/$organization/$project/app/$application/versions/$versionid',
    APPLICATION_UML: '/org/$organization/$project/app/$application/uml/',
    APPLICATION_REMOTES: '/org/$organization/$project/app/$application/remotes/',
    APPLICATION_MODULE: '/org/$organization/$project/app/$application/module/$module/',
    APPLICATION_DEPENDENCIES: '/org/$organization/$project/app/$application/analytics/dependencies/',
    APPLICATION_NODE_GRAPH: '/org/$organization/$project/app/$application/analytics/node-graph/',
    APPLICATION_NODE_DEPENDENCIES: '/org/$organization/$project/app/$application/analytics/node/$applicationId/dependencies/',
    APPLICATION_DEPENDENCY_GRAPH: '/org/$organization/$project/app/$application/analytics/dependency-graph/',
    APPLICATION_SETTINGS: '/org/$organization/$project/app/$application/settings',
    APPLICATION_SETTINGS_GENERAL: '/org/$organization/$project/app/$application/settings/general',
    APPLICATION_SETTINGS_COLLABORATORS: '/org/$organization/$project/app/$application/settings/collaborators',
    APPLICATION_SETTINGS_DEPLOYMENT_INTEGRATIONS: '/org/$organization/$project/app/$application/settings/deployment-integrations',
    APPLICATION_DEVOPS_RELEASE_PIPELINE: '/org/$organization/$project/app/$application/devops/release-pipeline',
    APPLICATION_DEVOPS_RELEASE_PIPELINE_BOARD: '/org/$organization/$project/app/$application/devops/release-pipeline-board',
    APPLICATION_DEVOPS_TAGS: '/org/$organization/$project/app/$application/devops/tags',
    APPLICATION_DEVOPS_TAGS_ADD: '/org/$organization/$project/app/$application/devops/tags/add',
    APPLICATION_DEVOPS_DEPLOYMENT_INTEGRATION_LIST: '/org/$organization/$project/app/$application/devops/deployment-integrations',
    // todo: should be discussed will be there tag id or tag name
    APPLICATION_DEVOPS_TAGS_EDIT: '/org/$organization/$project/app/$application/devops/tags/$tag',
    APPLICATION_DEVOPS_ENVIRONMENT_LIST: '/org/$organization/$project/app/$application/devops/environment',
    APPLICATION_DEVOPS_ENVIRONMENT_ADD: '/org/$organization/$project/app/$application/devops/environment/add',
    // todo: should be discussed will be there env id or env name
    APPLICATION_DEVOPS_ENVIRONMENT_EDIT: '/org/$organization/$project/app/$application/devops/environment/$environment',
    APPLICATION_DEVOPS_DEPLOYMENT_AND_ROLLBACK: '/org/$organization/$project/app/$application/devops/deployment-rollback/',
    APPLICATION_CONTRIBUTOR_LIST: '/org/$organization/$project/app/$application/settings/contributor-list',
    APPLICATION_ACTIVITY_CONTRIBUTORS: '/org/$organization/$project/app/$application/activity/contributors',
    /** User level */ USER_PROFILE: '/profile/$username/',
    USER_PROFILE_SETTINGS: '/profile/settings/',
    USER_PROFILE_SETTINGS_EMAILS: '/profile/settings/email-settings/',
    USER_PROFILE_SETTINGS_USER_TOKENS: '/profile/settings/user-tokens/',
    USER_PROFILE_SETTINGS_EDIT_USER_TOKEN: '/profile/settings/user-tokens/$userToken/',
    USER_PROFILE_SETTINGS_GENERATE_USER_TOKENS: '/profile/settings/user-tokens/generate/',
    AUTHENTICATED_USER_PROFILE: '/profile/',
    /** @deprecated */ NOTIFICATIONS: '/notifications',
    // #region Route Names from zephyr-worker-auth
    NOT_FOUND: '/404',
    /** @deprecated Routes, should be removed */ NOT_AUTHORIZED: '/401',
    FORBIDDEN: '/403',
    INTERNAL_ERROR: '/500',
    NEW_SUBSCRIBER: '/new-subscriber',
    CLI_LOGIN_SUCCESS: '/notifications/cli-login-success',
    CLI_LOGIN_FAILURE: '/notifications/cli-login-failure',
    SIDE_PANEL_LOGIN_SUCCESS: '/notifications/side-panel-login-success',
    SIDE_PANEL_LOGIN_FAILURE: '/notifications/side-panel-login-failure',
    AUTH_RESULT: '/auth/result/$origin/$status',
    AUTH_CONFIRM: '/auth/confirm'
};
